import { render, staticRenderFns } from "./creat.vue?vue&type=template&id=37389823&scoped=true&"
import script from "./creat.vue?vue&type=script&lang=js&"
export * from "./creat.vue?vue&type=script&lang=js&"
import style0 from "./creat.vue?vue&type=style&index=0&id=37389823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37389823",
  null
  
)

export default component.exports